import { Box } from '@mui/material';

import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';

import StatusBar from '@/designs-dev/device/StatusBar';
import ScreenRoot from '@/components/wrapped/ScreenRoot';

// Placeholder content for tabs that aren't designed yet (Chat).
const TabPlaceholder = ({ title }: { title: string }) => (
  <ScreenRoot>
    <StatusBar />
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
      }}
    >
      <PageHeader
        title={title}
        description='Not designed yet. Next up.'
        isCentered
      />
    </Box>
  </ScreenRoot>
);

export default TabPlaceholder;
